/*
 * @Author       : wenquan
 * @desc         : 智慧就业-指导网
 * @Date         : 2020-04-10 11:28:47
 * @LastEditTime : 2025-11-10 09:38:17
 * @LastEditors  : QLing
 * @FilePath     : /evalute-all/teaching_QualityService/src/main.js
 */
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import promise from 'es6-promise'
import ElementUI from 'element-ui'
import store from './store'
import './api/api.js'
import 'common/stylus/element-variables.scss'
import global from 'common/js/global-component.js' // 全局自定义指令
import 'common/js/public.js'
import echarts from 'echarts'
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import elementResizeDetectorMaker from 'element-resize-detector' // 容器监听
import scroll from 'vue-seamless-scroll' // 无缝滚动
import InputFloat from '@/util/InputFloat'
import text from 'api/text.js'
import 'echarts-wordcloud/dist/echarts-wordcloud.min'
import XLSX from 'xlsx'
require('echarts-wordcloud')
import VueClipBoard from 'vue-clipboard2'
//自定义指令-数字大小和位数限制

import '@/util/renderEllipsisHeader'

// 获取系统信息配置
let urlSys = `/configSetting/getConfigSettingMap`
Vue.prototype.$http
    .get(urlSys, {
        noAuth: true
    })
    .then(res => {
        res = res.content || null
        if (res) {
            Vue.prototype.$title = res.FRONT_NAME
            document.title = Vue.prototype.$title
            store.dispatch('setSystemInfo', res)
        }
    })

// 不需要token--全局参数问题
let url = `/notSensitiveConfig`
Vue.prototype.$http
    .get(url, {
        noAuth: true,
        keys: 'reportUrl,zhktUrl,appliTypeCodeText,attestationName,address,title,universityName'
    })
    .then(config => {
        Vue.prototype.$loginDescribe = config.content.loginDescribe
        Vue.prototype.$universityName = config.content.universityName
        Vue.prototype.$address = config.content.address
        Vue.prototype.$isAuthPassWrod = config.content.isAuthPassWrod
        Vue.prototype.$XLSX = XLSX
        Vue.prototype.$attestationName = (function () {
            //权限认证
            switch (config.content.attestationName) {
                case 'ligong':
                    Vue.prototype.$attestationUrl = '/login/integrationAuthenticationOurPlatform'
                default:
                    Vue.prototype.$attestationUrl = '/login/integrationAuthentication'
            }
            return config.content.attestationName
        })()
        Vue.directive('input-float', InputFloat)
        Vue.use(scroll)
        Vue.prototype.$erd = elementResizeDetectorMaker() // 容器监听
        Vue.prototype.$videojs = videojs
        Vue.prototype.$echarts = echarts
        Vue.config.productionTip = false
        promise.polyfill()
        Vue.use(global)
        Vue.use(ElementUI)
        Vue.use(text)
        Vue.use(VueClipBoard)

        router.beforeEach((to, from, next) => {
            if (!sessionStorage.getItem('loginInfo')) {
                console.log(to)
                if (!to.meta.requireAuth) {
                    next()
                } else {
                    next({
                        path: '/login',
                        query: {
                            redirect: to.fullPath
                        } // 将跳转的路由path作为参数，登录成功后跳转到该路由
                    })
                }
            } else {
                next()
            }
        })

        /* eslint-disable no-new */
        /* Array.isArray判定数组兼容性写法 */
        if (!Array.isArray) {
            Array.isArray = function (arg) {
                return Object.prototype.toString.call(arg) === '[object Array]'
            }
        }

        const _this = new Vue({
            el: '#app',
            router,
            store,
            render: h => h(App)
        })
        Vue.prototype.$main = _this.$children && _this.$children[0] // APP 公共组件
    })



// WEBPACK FOOTER //
// ./src/main.js